// Sources-tab search input — the feature's OWN Tailwind + logical-RTL box
// (the old mockup `components/PaneSearchBox` was `.tp-*`-styled; F-SOURCES
// shipped its own version per plan §2.3, and the mockup one is now removed).
//
// Pure presentation: holds the in-progress query string locally and fires
// `onSearch` on Enter or magnifier click. No business logic (W1) — the parent
// pane owns the search/filter glue via `useSources`/`useCaseSources`.

import { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface SourceSearchBoxProps {
  /** Fired with the current input value on Enter or magnifier click. */
  onSearch: (query: string) => void
}

export function SourceSearchBox({
  onSearch,
}: SourceSearchBoxProps): JSX.Element {
  const { t } = useTranslation()
  const [value, setValue] = useState('')

  const submit = (): void => onSearch(value)

  return (
    <div className="flex items-center gap-2 rounded-md border border-ink/15 bg-[var(--bg-card)] px-2 py-1.5">
      <button
        type="button"
        aria-label={t('sources.search')}
        onClick={submit}
        className="shrink-0 text-sm leading-none text-ink/50 hover:text-ink/80"
      >
        ⌕
      </button>
      <input
        type="search"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') submit()
        }}
        placeholder={t('sources.searchPlaceholder')}
        className="min-w-0 flex-1 bg-transparent text-xs text-ink outline-none placeholder:text-ink/40"
      />
    </div>
  )
}
